import React from 'react';
import Tab from 'react-bootstrap/Tab';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import ContainerTabs from '../../../components/TabsContainer/TabsContainer';
import { useGetOrganizationPaymentPermissionsQuery } from '../../../redux/apis/organizationApi';
import { selectCurrentOrganization } from '../../../selectors/organizationSelectors';
import DisputeDetails from '../DisputesDetails/DisputeDetails';
import DisputesTable from '../DisputesTable/DisputesTable';
import ExperientialRewardForm from '../ExperientialRewardForm/ExperientialRewardForm';
import PaymentsSettings from '../PaymentsSettings/PaymentsSettings';
import PaymentsTable from '../PaymentsTable/PaymentsTable';

import styles from './PaymentsTabs.module.scss';

const PaymentsTabs = ({ tab, subTab }) => {
  const { t } = useTranslation('common');
  const currentOrganization = useSelector(selectCurrentOrganization);
  const { data: paymentPermissions } = useGetOrganizationPaymentPermissionsQuery(
    { organizationId: currentOrganization?.id },
    { skip: !currentOrganization?.id }
  );
  const hidePayThroughBoon = paymentPermissions?.payload?.hide_pay_through_boon;

  return (
    <ContainerTabs tab={tab} tabsKey="payments">
      <Tab eventKey="records" title={t('payments.records')}>
        <div className={styles.tableContainer}>
          {subTab === 'experiential-reward-details' ? <ExperientialRewardForm /> : <PaymentsTable />}
        </div>
      </Tab>
      <Tab eventKey="disputes" title={t('payments.disputes')}>
        {subTab === 'dispute-details' ? (
          <DisputeDetails />
        ) : (
          <div className={styles.tableContainer}>
            <DisputesTable />
          </div>
        )}
      </Tab>
      {!hidePayThroughBoon && (
        <Tab eventKey="settings" title={t('settingsLabel')}>
          <PaymentsSettings />
        </Tab>
      )}
    </ContainerTabs>
  );
};

export default PaymentsTabs;
